export default __webpack_public_path__ + "adcf34c55717e89af61c6d458a1d791e.svg";